import { apiFetch } from './auth-service';
import { EnrollmentDoc } from './enrollment-service';

export interface QuizAttempt {
  _id: string;
  courseId: string;
  itemId: string;
  score: number;
  passed: boolean;
  createdAt: string;
}

export const getQuizAttempts = async (courseId?: string, itemId?: string): Promise<QuizAttempt[]> => {
  const params = new URLSearchParams();
  if (courseId) params.set('courseId', courseId);
  if (itemId)   params.set('itemId', itemId);
  const qs = params.toString() ? `?${params}` : '';
  const r = await apiFetch.get<{ attempts: QuizAttempt[] }>(`/quiz-attempts${qs}`);
  return r.attempts;
};

export const submitQuizAttempt = async (
  courseId: string,
  itemId: string,
  score: number,
  passed: boolean,
): Promise<{ attempt: QuizAttempt; enrollment: EnrollmentDoc | null }> => {
  return apiFetch.post('/quiz-attempts', { courseId, itemId, score, passed });
};
